module.exports = __webpack_public_path__ + "ef679601fd743fc6ef8f3d3c5690b0a5.fbx";